var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticStyle: { "margin-top": "20px" } }, [
    _vm.talentData.infoAiGenerate
      ? _c("div", { staticClass: "infoAiGenerate" }, [
          _vm._v("提示：文字内容由AI大模型生成，请仔细甄别"),
        ])
      : _vm._e(),
    _c("div", { staticClass: "text-left bottom-title" }, [
      _c("div", { staticClass: "messageTitle" }, [_vm._v("基本信息：")]),
      _c("div", { staticClass: "infoLine" }, [
        _c("div", { staticClass: "width-25" }, [
          _vm._m(0),
          _vm._v(" " + _vm._s(_vm.talentData.scholarVO?.scholarName) + " "),
        ]),
        _vm.talentData.scholarVO?.scholarOrg
          ? _c("div", { staticClass: "width-25" }, [
              _vm._m(1),
              _vm._v(" " + _vm._s(_vm.talentData.scholarVO?.scholarOrg) + " "),
            ])
          : _vm._e(),
      ]),
      _c("div", { staticClass: "infoLine" }, [
        _vm.talentData.scholarVO?.country
          ? _c("div", { staticClass: "width-25" }, [
              _vm._m(2),
              _vm._v(
                " " + _vm._s(_vm.talentData.scholarVO?.country || "-") + " "
              ),
            ])
          : _vm._e(),
        _vm.talentData.scholarVO?.estimatedAge
          ? _c("div", { staticClass: "width-25" }, [
              _vm._m(3),
              _vm._v(
                " " +
                  _vm._s(_vm.talentData.scholarVO?.estimatedAge || "-") +
                  " "
              ),
            ])
          : _vm._e(),
      ]),
      _c("div", { staticClass: "infoLine" }, [
        _vm.talentData.scholarVO?.phone
          ? _c("div", { staticClass: "width-25" }, [
              _c("div", [_vm._v("联系电话：")]),
              _vm._v(
                " " + _vm._s(_vm.talentData.scholarVO?.phone || "-") + " "
              ),
            ])
          : _vm._e(),
        _vm.talentData.scholarVO?.email
          ? _c("div", { staticClass: "width-25" }, [
              _vm._m(4),
              _vm._v(
                " " + _vm._s(_vm.talentData.scholarVO?.email || "-") + " "
              ),
            ])
          : _vm._e(),
      ]),
    ]),
    _vm.talentData.info
      ? _c("div", { staticClass: "text-left bottom-title" }, [
          _c("div", { staticClass: "messageTitle" }, [_vm._v("简介：")]),
          _c(
            "div",
            {
              staticStyle: { "line-height": "1.6", "white-space": "pre-wrap" },
            },
            [_vm._v(" " + _vm._s(_vm.talentData.info) + " ")]
          ),
        ])
      : _vm._e(),
    _vm.talentData.eduExperience
      ? _c("div", { staticClass: "text-left bottom-title" }, [
          _c("div", { staticClass: "messageTitle" }, [_vm._v("教育经历：")]),
          _c("div", {
            staticStyle: { "line-height": "1.6" },
            domProps: { innerHTML: _vm._s(_vm.talentData.eduExperience) },
          }),
        ])
      : _vm._e(),
    _vm.talentData.wordExperience
      ? _c("div", { staticClass: "text-left bottom-title" }, [
          _c("div", { staticClass: "messageTitle" }, [_vm._v("工作经历：")]),
          _c("div", {
            staticStyle: { "line-height": "1.6" },
            domProps: { innerHTML: _vm._s(_vm.talentData.wordExperience) },
          }),
        ])
      : _vm._e(),
    _vm.talentData.awards
      ? _c("div", { staticClass: "text-left bottom-title" }, [
          _c("div", { staticClass: "messageTitle" }, [_vm._v("获奖情况：")]),
          _c("div", { staticStyle: { "line-height": "1.5" } }, [
            _vm._v(_vm._s(_vm.talentData.awards)),
          ]),
        ])
      : _vm._e(),
    _vm.talentData.socialWork
      ? _c("div", { staticClass: "text-left bottom-title" }, [
          _c("div", { staticClass: "messageTitle" }, [_vm._v("社会兼职：")]),
          _c("div", { staticStyle: { "line-height": "1.5" } }, [
            _vm._v(_vm._s(_vm.talentData.socialWork)),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "flex justify-between" }, [
      _c("div", [_vm._v("姓")]),
      _c("div", { staticStyle: { "text-align": "right" } }, [_vm._v("名：")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "flex justify-between" }, [
      _c("div", [_vm._v("所在机构：")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "flex justify-between" }, [
      _c("div", [_vm._v("国")]),
      _c("div", { staticStyle: { "text-align": "right" } }, [_vm._v("籍：")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "flex justify-between" }, [
      _c("div", { staticStyle: { width: "84px" } }, [_vm._v("预估年龄段：")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "flex justify-between" }, [
      _c("div", [_vm._v("邮")]),
      _c("div", { staticStyle: { "text-align": "right" } }, [_vm._v("箱：")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }